import styled, { keyframes } from 'styled-components';

const androidlogo = keyframes`
  from {
    transform: rotate(180deg) translateY(150%);
  }
  to {
    transform: rotate(180deg) translateY(0%);
  }
`;
const androidBackArrow = keyframes`
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(50%);
  }
`;

export const AndroidLogo = styled.img`
    position: relative;
    width: 10.313em;
    height: 10.313em;
    transform: rotate(180deg) translateY(0%);
    animation: ${androidlogo} 2s ease;
    align-self: center;
    top: 0;
    @media screen and (min-width: 577px) {
        display: none;
    }
`;
export const AndroidBackArrow = styled.img`
    position: absolute;
    width: 50px;
    height: 50px;
    transform: translateY(50%);
    animation: ${androidBackArrow} 2s ease;
    top: 0;
    left: 20px;
    @media screen and (min-width: 577px) {
        display: none;
    }
`;
export const Wrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    min-height: 100vh !important;
    min-width: 100vw;
    box-sizing: border-box;
    /* @media screen and (min-width: 577px) {
    // общий внутренний отступ
      padding: 20px 50px;
    } */
`;

export const Link = styled.a`
    text-decoration: none;
    cursor: pointer;
`;
export const SubscriptionWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    & > div {
        margin-right: 20px;
    }
    & > div::last-child {
        margin-right: 0;
    }
    @media screen and (max-width: 576px) {
        flex-direction: column;
        align-self: center;
        & > div {
            margin-right: 0;
            margin-bottom: 20px;
        }
    }
`;
